import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment, { months } from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal, getMonthName } from "../General/Utility";

import imgLogo from "../../assets/images/logo.png";

import "../../assets/css/result-card.css";

const OldPrintResultCards = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorVariant, setErrorVariant] = useState("warning");
  const [showSecondExam, setShowSecondExam] = useState(false);
  const [showThirdExam, setShowThirdExam] = useState(false);
  const [showFourthExam, setShowFourthExam] = useState(false);

  const isSuccessStatus = (code) => code === 1 || code === "1";

  const toNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };

  const buildCumulativeRows = (item) => {
    const first = item.ListofFirstTermExamData || [];
    const second = item.ListofSecondTermExamData || [];
    const third = item.ListofThirdTermExamData || [];
    const fourth = item.ListofFourthTermExamData || [];

    return first.map((subj, idx) => {
      let total = toNumber(subj.Total_Marks);
      let obtained = toNumber(subj.Obtained_Marks);

      if (showSecondExam && second[idx]) {
        total += toNumber(second[idx].Total_Marks);
        obtained += toNumber(second[idx].Obtained_Marks);
      }
      if (showThirdExam && third[idx]) {
        total += toNumber(third[idx].Total_Marks);
        obtained += toNumber(third[idx].Obtained_Marks);
      }
      if (showFourthExam && fourth[idx]) {
        total += toNumber(fourth[idx].Total_Marks);
        obtained += toNumber(fourth[idx].Obtained_Marks);
      }

      return { total, obtained };
    });
  };

  useEffect(() => {
    document.title = "Print Old Result Cards";

    setLoading(true);
    setErrorMessage("");
    setLedger([]);

    const urlParams = new URLSearchParams(window.location.search);

    const FirstExamID = urlParams.get("FirstExamID");
    const SecondExamID = urlParams.get("SecondExamID");
    const ThirdExamID = urlParams.get("ThirdExamID");
    const FourthExamID = urlParams.get("FourthExamID");
    const Wing_Id = urlParams.get("WingId");
    const Class_Id = urlParams.get("ClassId");
    const Section_Id = urlParams.get("SectionId");

    const parseId = (value, label) => {
      if (value === null || value === "" || value === "0") {
        return { ok: false, message: `${label} is required. Go back to Old Results and select wing, class, and section.` };
      }
      const parsed = parseInt(value, 10);
      if (Number.isNaN(parsed) || parsed <= 0) {
        return { ok: false, message: `Invalid ${label} in the print link.` };
      }
      return { ok: true, value: parsed };
    };

    const firstExam = parseId(FirstExamID, "First exam");
    if (!firstExam.ok) {
      setErrorVariant("warning");
      setErrorMessage(firstExam.message);
      setLoading(false);
      return;
    }

    const wing = parseId(Wing_Id, "Wing");
    if (!wing.ok) {
      setErrorVariant("warning");
      setErrorMessage(wing.message);
      setLoading(false);
      return;
    }

    const classRow = parseId(Class_Id, "Class");
    if (!classRow.ok) {
      setErrorVariant("warning");
      setErrorMessage(classRow.message);
      setLoading(false);
      return;
    }

    if (!AccessKey || !UserID) {
      setErrorVariant("danger");
      setErrorMessage("Your session has expired. Please log in again, then open Print Old Result Cards from Old Results.");
      setLoading(false);
      return;
    }

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      FirstExamID: firstExam.value,
      SecondExamID: SecondExamID ? parseInt(SecondExamID, 10) || 0 : 0,
      ThirdExamID: ThirdExamID ? parseInt(ThirdExamID, 10) || 0 : 0,
      FourthExamID: FourthExamID ? parseInt(FourthExamID, 10) || 0 : 0,
      Wing_Id: wing.value,
      Class_Id: classRow.value,
      Section_Id: Section_Id ? parseInt(Section_Id, 10) || 0 : 0,
    };

    setShowSecondExam(data.SecondExamID > 0);
    setShowThirdExam(data.ThirdExamID > 0);
    setShowFourthExam(data.FourthExamID > 0);

    axios({
      method: "post",
      url: config.base_url + "Exam/GetOldResultCard",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    })
      .then(function (response) {
        const payload = response?.data;
        const statusCode = payload?.status_code;

        if (isSuccessStatus(statusCode)) {
          const students = payload?.ListofStudents || [];
          if (students.length === 0) {
            setErrorVariant("warning");
            setErrorMessage(
              "No result card data found for the selected exam, wing, class, and section. " +
              "Confirm that exam marks exist in tblExamData for these filters (students who changed session still appear only if they have marks under this wing/class/section)."
            );
            setLedger([]);
          } else {
            setLedger(students);
            setErrorMessage("");
          }
        } else {
          setLedger([]);
          setErrorVariant(statusCode === 2 || statusCode === "2" ? "danger" : "warning");
          setErrorMessage(
            payload?.status_message ||
            "Unable to load old result cards. Please check your selection and try again."
          );
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLedger([]);
        setErrorVariant("danger");
        const networkDetail =
          error?.response?.data?.status_message ||
          error?.message ||
          "";
        setErrorMessage(
          networkDetail
            ? `Could not load result cards: ${networkDetail}`
            : "Network error while loading result cards. Check your connection and try again."
        );
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center p-5">
          <Spinner animation="border" role="status" className="me-2" />
          <span>Loading old result cards…</span>
        </div>
      ) : errorMessage ? (
        <div
          className={`alert alert-${errorVariant} m-4`}
          role="alert"
          style={{ maxWidth: "720px", margin: "2rem auto" }}
        >
          <h5 className="alert-heading mb-2">Cannot print old result cards</h5>
          <p className="mb-2">{errorMessage}</p>
          <hr />
          <p className="mb-0 small text-muted">
            Tip: Open{" "}
            <a href="/ExaminationSystem/OldResults">Print Old Results</a>, select the
            first exam, wait for wing/class/section to load, then try again.
          </p>
        </div>
      ) : (
        listOfLedger.map((item, index) => (
          <div key={index}>
            <Page orientation="portrait" size="a4">
               <PrintHeader />
               <div className="old-result-title-block">
                 <h2 className="old-result-main-title">PROVISIONAL RESULT INTIMATION</h2>
                 {item.Father_CNIC ? (
                   <div className="old-result-exam-names">
                     {String(item.Father_CNIC)
                       .split(/\s*\/\s*/)
                       .map((name) => name.trim())
                       .filter(Boolean)
                       .map((name, examIndex, examList) => (
                         <React.Fragment key={examIndex}>
                           <span className="old-result-exam-name">{name}</span>
                           {examIndex < examList.length - 1 ? (
                             <span className="old-result-exam-sep">•</span>
                           ) : null}
                         </React.Fragment>
                       ))}
                   </div>
                 ) : null}
               </div>
              
              <div className="student-info-header">
                <table>
                  <tbody>
                    <tr>
                      <td style={{ width: "85%" }}>
                        <table className="w-100">
                          <tbody>
                            <tr>
                              <td>
                                <div className="option">
                                  <span className="label">Name:</span>
                                  <span className="value">
                                    {item.Student_Name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Father’s Name:</span>
                                  <span className="value">
                                    {item.Father_Name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Result:</span>
                                  <span className="value"></span>
                                </div>
                              </td>
                            </tr>
                          
                            <tr>
                              <td>
                                <div className="option">
                                  <span className="label">
                                    Class / Section:{" "}
                                  </span>
                                  <span className="value">
                                    {item.Class_Name}/{item.Section_Name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Sr. No:</span>
                                  <span className="value">
                                    {item.Serial_No}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="option">
                                  <span className="label">Reg. No.</span>
                                  <span className="value">
                                    {item.Registration_No}
                                  </span>
                                </div>
                              </td>
                              <td style={{ width: "150px" }}>
                                <div className="option">
                                  <span className="label">Date:</span>
                                  <span className="value"></span>
                                </div>
                              </td>
                            </tr>
                          
                            <tr>
                              <td colSpan={3}>
                                <div className="option">
                                  <span className="label">Address:</span>
                                  <span className="value">
                                    {item.Permanent_Address}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td
                        style={{
                          width: "15%",
                          verticalAlign: "top",
                          textAlign: "right",
                        }}
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="result-card-body">
                <table className="marks-layout">
                  <tbody>
                    <tr>
                      <td style={{ width: showSecondExam || showThirdExam || showFourthExam ? "28%" : "55%", verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="3">First Term</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="subject">
                                <strong>Subject</strong>
                              </td>
                              <td>
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>

                            {(item.ListofFirstTermExamData || []).map(
                              (firstexam, index) => (
                                <tr key={index}>
                                  <td className="subject-name">{firstexam.Name}&nbsp;</td>
                                  <td>
                                    {firstexam.Total_Marks > 0 ? (
                                      firstexam.Total_Marks
                                    ) : (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: "&nbsp;",
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td>{firstexam.Obtained_Marks}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                      {showSecondExam && (
                      <td style={{ width: "18%", verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="2">Second Term</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="marks">
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>

                            {(item.ListofSecondTermExamData || []).map(
                              (secondexam, index) => (
                                <tr key={index}>
                                  <td>
                                    {secondexam.Total_Marks > 0 ? (
                                      secondexam.Total_Marks
                                    ) : (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: "&nbsp;",
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td>{secondexam.Obtained_Marks}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                      )}
                      {showThirdExam && (
                      <td style={{ width: "18%", verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="2">Third Term</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="marks">
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>

                            {(item.ListofThirdTermExamData || []).map(
                              (thirdexam, index) => (
                                <tr key={index}>
                                  <td>
                                    {thirdexam.Total_Marks > 0 ? (
                                      thirdexam.Total_Marks
                                    ) : (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: "&nbsp;",
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td>{thirdexam.Obtained_Marks}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                      )}
                      {showFourthExam && (
                      <td style={{ width: "18%", verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="2">Fourth Term</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="marks">
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>

                            {(item.ListofFourthTermExamData || []).map(
                              (fourthexam, index) => (
                                <tr key={index}>
                                  <td>
                                    {fourthexam.Total_Marks > 0 ? (
                                      fourthexam.Total_Marks
                                    ) : (
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: "&nbsp;",
                                        }}
                                      />
                                    )}
                                  </td>
                                  <td>{fourthexam.Obtained_Marks}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </td>
                      )}
                      <td style={{ width: showSecondExam || showThirdExam || showFourthExam ? "18%" : "45%", verticalAlign: "top" }}>
                        <table className="table-bordered">
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="2">Cumulative</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr className="greyback">
                              <td className="marks">
                                <strong>Total Marks</strong>
                              </td>
                              <td>
                                <strong>Obtained Marks</strong>
                              </td>
                            </tr>

                            {buildCumulativeRows(item).map((row, index) => (
                              <tr key={`cum-${index}`}>
                                <td>{row.total > 0 ? row.total : "\u00A0"}</td>
                                <td>{row.obtained.toFixed(2)}</td>
                              </tr>
                            ))}
                            <tr className="marks-total-row">
                              <td>
                                <strong>
                                  {buildCumulativeRows(item).reduce(
                                    (sum, row) => sum + row.total,
                                    0
                                  )}
                                </strong>
                              </td>
                              <td>
                                <strong>
                                  {buildCumulativeRows(item)
                                    .reduce((sum, row) => sum + row.obtained, 0)
                                    .toFixed(2)}
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <div className="result-card-body">
                <table className="w-100">
                  <tbody>
                    <tr>
                      <td valign="top">
                        <table className="table-bordered learning-feedback w-100">
                          <colgroup>
                            <col className="feedback-label-col" />
                            <col className="feedback-tick-col" />
                            <col className="feedback-tick-col" />
                            <col className="feedback-tick-col" />
                            <col className="feedback-tick-col" />
                          </colgroup>
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="5">Your Child as a Learner</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="feedback-label"></td>
                              <td className="feedback-tick">
                                <i className="ri-emotion-normal-line"></i>
                                <span>Rarely</span>
                              </td>
                              <td className="feedback-tick">
                                <i className="ri-emotion-happy-line"></i>
                                <span>Sometimes</span>
                              </td>
                              <td className="feedback-tick">
                                <i className="ri-emotion-line"></i>
                                <span>Mostly</span>
                              </td>
                              <td className="feedback-tick">
                                <i className="ri-emotion-line"></i>
                                <span>Always</span>
                              </td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Listens class attentively</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Responsible with homework</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Works neatly and orderly</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>

                          </tbody>
                          <thead style={{ textAlign: "center" }}>
                            <tr className="greyback">
                              <th colSpan="5">Your child's social and personal development</th>
                            </tr>
                          </thead>
                          <tbody>

                            <tr>
                              <td className="feedback-label">Remains pleasant in Class</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Behaves well with classmates</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Respects his elders</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Sensitive to other's feelings</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>
                            <tr>
                              <td className="feedback-label">Hates the wrong doings</td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                              <td className="feedback-tick"></td>
                            </tr>

                          </tbody>
                        </table>
                      </td>
                      <td style={{ verticalAlign: "top" }}>
                        <ul className="stars-list">
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Experiencing Significent Difficulty</span>
                          </li>
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Managing Comfortably</span>
                          </li>
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Capable and Competent</span>
                          </li>
                          <li>
                            <i className="ri-star-fill"></i>
                            <span>Highly Capable and Competent</span>
                          </li>
                        </ul>
                        <table className="table-bordered learning-starts w-100">
                          <colgroup>
                            <col className="learning-label-col" />
                            <col className="learning-star-col" />
                            <col className="learning-star-col" />
                            <col className="learning-star-col" />
                            <col className="learning-star-col" />
                          </colgroup>
                          <thead>
                            <tr className="greyback">
                              <th colSpan="5">
                                Your Child's Learning During 1st Semester
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="learning-label">English / Urdu</td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                              <td className="learning-star">
                                <i className="ri-star-fill"></i>
                              </td>
                            </tr>
                            <tr>
                              <td className="learning-label">Listening Comprehension</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                            <tr>
                              <td className="learning-label">Oral Expression / Speaking</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                            <tr>
                              <td className="learning-label">Reading</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                            <tr>
                              <td className="learning-label">Written Expression</td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                              <td className="learning-star"></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <table className="table-bordered learning-feedback w-100">
                          <thead>
                            <tr className="greyback">
                              <th>Term</th>
                              <th>Total Marks</th>
                              <th>Obtained Marks</th>
                              <th>Result</th>
                              <th>Class Position</th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr>
                              <td>First Term</td>
                              <td>{item.FirstTermObtained_Marks}</td>
                              <td>
                                {item.FirstTermPercentMarks > 0 ? (
                                  <span>
                                    ({item.FirstTermPercentMarks}%)
                                    {item.FirstTermClass_Position}
                                  </span>
                                ) : (
                                  <span>&nbsp;</span>
                                )}
                              </td>
                              <td>{item.FirstTermGrade}</td>
                              <td>{item.FirstTermClass_Position}</td>
                            </tr>
                            {showSecondExam && (
                            <tr>
                              <td>Second Term</td>
                              <td>{item.SecondTermObtained_Marks}</td>
                              <td>
                                {item.SecondTermPercentMarks > 0 ? (
                                  <span>
                                    ({item.SecondTermPercentMarks}%)
                                    {item.SecondTermClass_Position}
                                  </span>
                                ) : (
                                  <span>&nbsp;</span>
                                )}
                              </td>
                              <td>{item.SecondTermGrade}</td>
                              <td>{item.SecondTermClass_Position}</td>
                            </tr>
                            )}
                            {showThirdExam && (
                            <tr>
                              <td>Third Term</td>
                              <td>{item.ThirdTermObtained_Marks}</td>
                              <td>
                                {item.ThirdTermPercentMarks > 0 ? (
                                  <span>
                                    ({item.ThirdTermPercentMarks}%)
                                    {item.ThirdTermClass_Position}
                                  </span>
                                ) : (
                                  <span>&nbsp;</span>
                                )}
                              </td>
                              <td>{item.ThirdTermGrade}</td>
                              <td>{item.ThirdTermClass_Position}</td>
                            </tr>
                            )}
                            {showFourthExam && (
                            <tr>
                              <td>Fourth Term</td>
                              <td>{item.FourthTermObtained_Marks}</td>
                              <td>
                                {item.FourthTermPercentMarks > 0 ? (
                                  <span>
                                    ({item.FourthTermPercentMarks}%)
                                    {item.FourthTermClass_Position}
                                  </span>
                                ) : (
                                  <span>&nbsp;</span>
                                )}
                              </td>
                              <td>{item.FourthTermGrade}</td>
                              <td>{item.FourthTermClass_Position}</td>
                            </tr>
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <div className="remarks">
                          <h4 style={{ margin: "0" }}>Teacher's Remarks</h4>
                          <div>
                            <div className="option">
                              <span className="value">&nbsp;</span>
                            </div>
                            <div
                              className="option"
                              style={{ marginTop: "5px" }}
                            >
                              <span className="value">&nbsp;</span>
                            </div>
                          </div>
                        </div>

                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <table className="rc-footer w-100 mt-3">
                          <tbody>
                            <tr>
                              <td style={{width:"33%"}}>
                                <div className="option">
                                  <h4 className="m-0">Prepared By:</h4>
                                  <span className="value"></span>
                                </div>
                              </td>
                              <td style={{width:"33%"}}>
                                <img
                                  src="/images/signatures/controlexams.png"
                                  style={{
                                    width: "100px",
                                    border: "0px",
                                    marginTop: "-86px",
                                    marginBottom: "0px",
                                    marginRight: "0px",
                                  }}
                                  alt=""
                                />
                                <h4 className="m-0">Controller Examination</h4>

                              </td>
                              <td style={{width:"33%"}}>
                                <img
                                  src="/images/signatures/principal.png"
                                  style={{
                                    width: "135px",
                                    border: "0px",
                                    float: "right",
                                    marginTop: "-70px",
                                    marginLeft: "-85px",
                                    marginBottom: "0px",
                                    marginRight: "0px",
                                  }}
                                  alt=""
                                />
                                <h4 className="m-0">Principal</h4>

                              </td>
                            </tr>
                            <tr>
                              <td colSpan={3} style={{ fontSize: "9pt", textAlign: "center" }}>
                                Note: This provisional result intimation is issued as a
                                notice only. Errors and omissions are accepted.
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Page >
          </div>

        ))
      )}
    </>
  );
};

export default OldPrintResultCards;
